<template>
    <div>
        <el-dialog :title="titleName" :visible.sync="dialogFormVisible" class="qazqaz" width="100%">
            <div class="viewVcloud-main-body-B container">
                <div id="mainbodyVouchers" class="page-wrap">
                    <form id="vouchersForm" class="form-inline">
                        <div class="titlebread" style="height: 56px;">
                            <div class="pull-right">
                                <el-button size="small" @click="handleAdd()"
                                           style="background-color:#e4ecfd;color: #3c4c8a;margin-left: 5px;border: 1px solid #91a9e2;border-radius: 0px;">
                                    保存模版
                                </el-button>
                                <el-button size="small" @click="dialogFormVisible = false"
                                           style="background-color:red;color: white;margin-left: 5px;border: 1px solid red;border-radius: 0px;">
                                    取 消
                                </el-button>
                                <span class="lightblue-btn small-btn glyphicon glyphicon-retweet togglebtn isNotAdd"
                                      style="top: 0px; display: none;"></span>
                            </div>
                            <div class="voucher_tit">
                                <h1>凭证模版</h1>
                            </div>
                            <div class="forV">
                                <span class="serialNum">
                                    <span style="color: red">*</span>
                                    <span style="margin-right: 5px;font-size: 16px;">模版名称：</span>
                                    <el-input size="small"
                                              style="width: 166px;background-color: #ffffff;margin-right: 6px;"
                                              v-model="form.mbna"/>

                                    <span style="color: red;margin-left: 15px;">*</span>
                                    <span style="font-size: 16px;">状态：</span>
                                    <el-radio-group v-model="form.sta">
                                        <el-radio label="0" style="margin-right: 10px;">正常</el-radio>
                                        <el-radio label="1">停用</el-radio>
                                    </el-radio-group>

                                </span>
                            </div>
                            <div id="tag"></div>
                        </div>
                        <div class="form" style="margin-left: -30px;">
                            <table class="table table-striped v-table" id="voucherTable">
                                <colgroup>
                                    <col width="30">
                                    <col width="">
                                    <col width="349">
                                    <col width="219">
                                    <col width="219">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th class="table-edge"></th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">摘要</strong>
                                    </th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">会计科目</strong>
                                    </th>
                                    <th style="vertical-align: middle;">
                                        <strong style="font-size: 13.5px;">借方金额</strong>
                                        <div class="money_unit">
                                            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span>
                                            <span>千</span> <span>百</span> <span>十</span> <span>元</span> <span>角</span>
                                            <span class="last">分</span>
                                        </div>
                                    </th>
                                    <th>
                                        <strong style="font-size: 13.5px;">贷方金额</strong>
                                        <div class="money_unit">
                                            <span>亿</span> <span>千</span> <span>百</span> <span>十</span> <span>万</span>
                                            <span>千</span> <span>百</span> <span>十</span> <span>元</span> <span>角</span>
                                            <span class="last">分</span>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                </tbody>
                                <!--<tfoot>
                                <tr>
                                    <td class="table-edge"></td>
                                    <td colspan="2" class="heji" style="vertical-align: middle;">
                                        <strong id="hja">&nbsp;&nbsp;合计：<span id="hejizw"></span></strong>
                                    </td>
                                    <td class="v-money"></td>
                                    <td class="v-money"></td>
                                </tr>
                                </tfoot>-->
                            </table>
                        </div>
                    </form>
                </div>
                <!-- 凭证页面 -->
                <div class="div-ui"></div>
            </div>
        </el-dialog>

    </div>

</template>

<script>
    import $ from 'jquery'
    import "@/plugins/pingzheng/stylecopy.css";

    export default {
        data() {
            return {
                dialogFormVisible: true,
                titleName: '',
                form: {
                    id: null,
                    sta: '0',
                    mbna: '',
                    pinJieCanShu: '',
                    childList: []
                }
            };
        },
        methods: {
            int(id, type) {
                this.dialogFormVisible = true;

                this.form.id = id;
                this.form.sta = '0';
                this.form.mbna = '';

                if (type == 0) {
                    this.titleName = "新增凭证模版";
                    this.url = "/business/fuZhuPzmb/save";
                    this.$nextTick(() => {
                        this.initAdd();
                        $("tfoot .v-money").html('<div class="v-data">000</div>');
                        $("tfoot .v-money").css("color", "#39f");
                    })
                } else {
                    if (type == 1) {
                        this.titleName = "修改凭证模版";
                        this.url = "/business/fuZhuPzmb/update";
                    }
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuPzmb/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                        if (this.form) {
                            let array = this.form.childList;
                            $("#voucherTable tbody").empty();
                            for (let i = 0; i < array.length; i++) {
                                this.vdEdit(array[i]);
                            }
                        }
                    })
                }
            },
            initAdd() {
                $("#voucherTable tbody").empty();
                for (let i = 0; i < 6; i++) {
                    this.vdadd(null);
                }
            },
            vdadd(obj) {
                let trObj = '<tr class="voucher-tr" data-id="' + (this.getUUID()) + '"><td align="center" class="table-edge"></td><td data-type="brief"></td><td data-type="km" kmCode="" kmName=""></td><td data-type="money" class="v-money"></td><td data-type="money" class="v-money v-money2"></td></tr>';
                if (!obj) {
                    $("#voucherTable tbody").append(trObj);
                } else {
                    $(obj).parents(".voucher-tr").after(trObj);
                }
                this.eventObj();
            },
            vdEdit(dataObj) {
                let trObj = '' +
                    '<tr class="voucher-tr" data-id="' + (dataObj.id) + '">' +
                    '<td align="center" class="table-edge"></td>' +
                    '<td data-type="brief">' + (dataObj.zyJl == null ? '' : dataObj.zyJl) + '</td>' +
                    '<td data-type="km" kmCode="' + (dataObj.kmdm == null ? '' : dataObj.kmdm) + '" kmName="' + (dataObj.kmmc == null ? '' : dataObj.kmmc) + '">' + (dataObj.kmdm == null ? '' : dataObj.kmdm) + ' ' + (dataObj.kmmc == null ? '' : dataObj.kmmc) + '</td>' +
                    '<td data-type="money" class="v-money">' + (dataObj.jfje == null ? '' : ('<div class="v-data">' + dataObj.jfje + '</div>')) + '</td>' +
                    '<td data-type="money" class="v-money v-money2">' + (dataObj.dfje == null ? '' : ('<div class="v-data">' + dataObj.dfje + '</div>')) + '</td>' +
                    '</tr>';
                $("#voucherTable tbody").append(trObj);
                this.eventObj();
            },
            eventObj() {
                $(".voucher-tr").off();
                $(".voucher-tr").hover(
                    function () {
                        $(this).find(".table-edge").empty();
                        let ul = '<ul class="operatebtn"><li class="img-plus-sign vd-add" onclick="vdadd(this);"></li><li class="img-minus-sign vd-remove" onclick="vdremove(this)"></li></ul>'
                        $(this).find(".table-edge").append(ul);
                    },
                    function () {
                        $(this).find(".table-edge").empty();
                    }
                );
                //金额点击事件
                $("tbody .v-money").off();
                $("tbody .v-money").click(function () {
                    if ($(this).find(".v-data").length && $(this).find(".v-data").length > 0) {
                        let valuedate = $(this).find(".v-data").text() / 100;
                        let input = '<div class="text-auto-wrap"><input class="text-auto" style="text-align: center" onkeyup="num(this)" value="' + valuedate + '"></div>';
                        $(this).empty();
                        $(this).append(input);

                        //指定贯标最右边定位
                        let inputFocus = $(this).find(".text-auto");
                        let val = inputFocus.val();
                        inputFocus.focus();
                        inputFocus.val('');
                        inputFocus.val(val);
                        inputFocus.select();

                        $(this).find(".text-auto").blur(function () {
                            let valuedate = $(this).val();
                            let parenttd = $(this).parents(".v-money");
                            if (valuedate == null || valuedate == "") {
                                parenttd.empty();
                            } else {
                                let vstr;
                                if (String(valuedate).indexOf(".") > -1) {
                                    if (String(valuedate).split(".")[1].length == 1) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1] + "0";
                                    } else if (String(valuedate).split(".")[1].length == 2) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1];
                                    } else if (String(valuedate).split(".")[1].length > 2) {
                                        vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1].substring(0, 2);
                                    } else {
                                        vstr = valuedate;
                                    }
                                } else {
                                    vstr = valuedate + "00";
                                }

                                let data = '<div class="v-data">' + vstr + '</div>';
                                parenttd.empty();
                                parenttd.append(data);
                            }
                        });

                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();

                        } else {
                            var input = '<div class="text-auto-wrap"><input class="text-auto" style="text-align: center" onkeyup="num(this)" value=""></div>';
                            $(this).empty();
                            $(this).append(input);

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();

                            $(this).find(".text-auto").blur(function () {
                                let valuedate = $(this).val();
                                let parenttd = $(this).parents(".v-money");
                                if (valuedate == null || valuedate == "") {
                                    parenttd.empty();
                                } else {
                                    let vstr;
                                    if (String(valuedate).indexOf(".") > -1) {
                                        if (String(valuedate).split(".")[1].length == 1) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1] + "0";
                                        } else if (String(valuedate).split(".")[1].length == 2) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1];
                                        } else if (String(valuedate).split(".")[1].length > 2) {
                                            vstr = String(valuedate).split(".")[0] + String(valuedate).split(".")[1].substring(0, 2);
                                        } else {
                                            vstr = valuedate;
                                        }
                                    } else {
                                        vstr = valuedate + "00";
                                    }

                                    let data = '<div class="v-data">' + vstr + '</div>';
                                    parenttd.empty();
                                    parenttd.append(data);
                                }
                            });
                        }
                    }
                });

                //摘要点击事件
                $("td[data-type='brief']").off();
                $("td[data-type='brief']").click(function () {
                    $(this).addClass("v-edit");
                    if ($(this).text() != "" && $(this).text() != null) {
                        let valuedate = $(this).text();
                        let input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="zychange(this)" value="' + valuedate + '"></div>';
                        $(this).empty();
                        $(this).append(input);

                        $(this).find("input").keyup(function () {
                            $("input").css("background-color", "#D6D6FF");
                        });

                        //指定贯标最右边定位
                        let inputFocus = $(this).find(".text-auto");
                        let val = inputFocus.val();
                        inputFocus.focus();
                        inputFocus.val('');
                        inputFocus.val(val);
                        inputFocus.select();

                        $(this).find(".text-auto").blur(function () {
                            let valuedate = $.trim($(this).val());
                            let parenttd = $(this).parents("td[data-type='brief']");
                            if (valuedate == null || valuedate == "") {
                                parenttd.empty();
                            } else {
                                parenttd.empty();
                                parenttd.text(valuedate);
                            }
                            parenttd.removeClass("v-edit");
                        });

                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {
                            $(this).find(".text-auto").focus();
                        } else {
                            var input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="zychange(this)" value=""></div>';
                            $(this).empty();
                            $(this).append(input);

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();

                            $(this).find(".text-auto").blur(function () {
                                let valuedate = $.trim($(this).val());
                                let parenttd = $(this).parents("td[data-type='brief']");
                                if (valuedate == null || valuedate == "") {
                                    parenttd.empty();
                                } else {
                                    parenttd.empty();
                                    parenttd.text(valuedate);
                                }
                                parenttd.removeClass("v-edit");
                            });
                        }
                    }
                });

                //科目点击事件
                $("td[data-type='km']").off();
                $("td[data-type='km']").click(function () {
                    $(this).addClass("v-edit");
                    if ($(this).text() != "" && $(this).text() != null) {
                        let valuedate = $(this).text();
                        km_f($(this), valuedate);
                    } else {
                        if ($(this).find(".text-auto").length && $(this).find(".text-auto").length > 0) {

                            //指定贯标最右边定位
                            let inputFocus = $(this).find(".text-auto");
                            let val = inputFocus.val();
                            inputFocus.focus();
                            inputFocus.val('');
                            inputFocus.val(val);
                            inputFocus.select();

                        } else {
                            km_f($(this), "");
                        }
                    }
                    //添加科目选者框
                    initselect($(this));
                });
            },
            vdremove(obj) {
                if ($(".voucher-tr").length > 2) {
                    $(obj).parents(".voucher-tr").remove();
                } else {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "至少保留两条分录！"
                    })
                }
            },
            getUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
                })
            },
            initselect(clickObj) {
                let div = '';

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getDicKmByLikeCodeOrName'),
                    method: 'post',
                    data: {dicCodeOrName: $.trim(clickObj.find(".text-auto").val())}
                }).then(r => {
                    $.each(r.data.data, function (i, obj) {
                        div += '<div class="div-li" kmCode="' + obj.dicCode + '" kmName="' + obj.fullName + '" >' + obj.dicCode + ' ' + obj.fullName + '</div>';
                    });

                    $(".div-ui").show();

                    $(".div-ui").empty();
                    $(".div-ui").append(div);
                    $(".div-ui").width(clickObj.innerWidth() - 2);
                    $(".div-ui").offset({top: clickObj.offset().top + clickObj.innerHeight()});
                    $(".div-ui").offset({left: clickObj.offset().left});

                    $(".div-li").hover(
                        function () {
                            $(this).addClass("hover");
                        },
                        function () {
                            $(this).removeClass("hover");
                        }
                    );

                    $(".div-li").on("mousedown", function () {

                        clickObj.text($(this).text());
                        clickObj.attr("kmCode", $(this).attr("kmCode"));
                        clickObj.attr("kmName", $(this).attr("kmName"));

                        clickObj.removeClass("v-edit");
                        $(".div-ui").hide();
                    });
                }).finally(r => {
                })
            },
            km_f(thisobj, valuedate) {
                let input = '<div class="text-auto-wrap"><input class="text-auto" onkeyup="findKm(this)" value="' + valuedate + '"></div>';
                thisobj.empty();
                thisobj.append(input);

                //指定贯标最右边定位
                let inputFocus = thisobj.find(".text-auto");
                let val = inputFocus.val();
                inputFocus.focus();
                inputFocus.val('');
                inputFocus.val(val);
                inputFocus.select();

                thisobj.find(".text-auto").blur(function () {
                    let valuedate = $.trim($(this).val());
                    let parenttd = $(this).parents("td[data-type='km']");

                    let parenttdValue = parenttd.attr("kmCode") + " " + parenttd.attr("kmName");
                    if (valuedate == null || valuedate == "" || valuedate != parenttdValue) {
                        parenttd.empty();
                        parenttd.attr("kmCode", "");
                        parenttd.attr("kmName", "");
                    } else {
                        parenttd.empty();
                        parenttd.text(valuedate);
                    }
                    parenttd.removeClass("v-edit");
                    $(".div-ui").hide();

                });
            },
            findKm(obj) {
                let parenttd = $(obj).parents("td[data-type='km']");
                this.initselect(parenttd);
            },
            num(obj) {

                //监控补充输入
                if ($(obj).val() == "=") {

                    //清空借、贷金额  借贷只能填写一个
                    let vm = $(obj).parents(".v-money");
                    vm.siblings(".v-money").empty();

                    var jieMoney = 0;
                    var daiMoney = 0;
                    $.each($("tbody .v-money"), function (i, obj) {
                        if ($(obj).hasClass("v-money2")) {
                            if ($(obj).text() != "" && $(obj).text() != null) {
                                daiMoney += parseFloat($(obj).text());
                            }
                        } else {
                            if ($(obj).text() != "" && $(obj).text() != null) {
                                jieMoney += parseFloat($(obj).text());
                            }
                        }
                    });

                    if (vm.hasClass("v-money2")) {
                        //当前是贷方金额
                        $(obj).val((jieMoney - daiMoney) / 100);
                    } else {
                        //当前是借方金额
                        $(obj).val((daiMoney - jieMoney) / 100)
                    }

                } else {

                    obj.value = obj.value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                    obj.value = obj.value.replace(/^\./g, ""); //验证第一个字符是数字
                    obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                    obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
                    if (obj.value.indexOf(".") > -1) {
                        if (obj.value.split(".")[0].length > 9) {
                            obj.value = obj.value.substring(0, 9) + obj.value.split(".")[1];
                        }
                        if (obj.value.split(".")[0].length > 1 && parseInt(obj.value.split(".")[0].substring(0, 1)) == 0) {
                            obj.value = obj.value.substring(1, obj.value.length);
                        }
                    } else {
                        if (obj.value.length > 9) {
                            obj.value = obj.value.substring(0, 9);
                        }
                        if (obj.value.length > 1 && parseInt(obj.value.substring(0, 1)) == 0) {
                            obj.value = obj.value.substring(1, obj.value.length);
                        }
                    }

                    //清空借、贷金额  借贷只能填写一个
                    let vm = $(obj).parents(".v-money");
                    vm.siblings(".v-money").empty();

                }

            },
            handleAdd() {
                this.toAdd();
            },
            toAdd() {


                if (!this.form.mbna) {
                    this.$message({
                        type: 'warning',
                        message: "模版名称为空！"
                    })
                    return;
                }

                if (!this.form.sta) {
                    this.$message({
                        type: 'warning',
                        message: "状态未选择！"
                    })
                    return;
                }

                var pinJieCanShu = "";
                var bool = false;
                var msg = "";
                var tdObj;
                //校验是否存在未填项
                $.each($(".voucher-tr"), function (i, tr) {

                    var tds = $(tr).find("td");

                    var zy = $.trim($(tds[1]).text());//摘要
                    var kudm = $.trim($(tds[2]).attr("kmCode"));//会计科目代码
                    var kumc = $.trim($(tds[2]).attr("kmName"));//会计科目名称
                    var jfje = $.trim($(tds[3]).text());//借方金额
                    var dfje = $.trim($(tds[4]).text());//贷方金额

                    if (zy == "" && kudm == "" && jfje == "" && dfje == "") {
                        return;
                    }

                    if (zy == "") {
                        msg = "请填写摘要！";
                        tdObj = $(tds[1]);
                        bool = true;
                        return false;
                    }
                    if (kudm == "") {
                        msg = "请选择科目！";
                        tdObj = $(tds[2]);
                        bool = true;
                        return false;
                    }

                    //借贷金额标识
                    var biaoshi = "";
                    var biaoShiJinE;

                    if (jfje != "") {
                        biaoshi = "jfje";
                        biaoShiJinE = jfje;//金额单位（分）
                    } else {
                        biaoshi = "dfje";
                        biaoShiJinE = dfje;//金额单位（分）
                    }

                    //数据拼装
                    pinJieCanShu += (zy + "=" + kudm + "=" + kumc + "=" + biaoshi + "=" + biaoShiJinE + ",");//顺次是:摘要+科目代码+科目名称+借贷金额标识+借贷金额（分）

                });

                if (bool) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: msg
                    })
                    tdObj.click();
                    return false;
                }

                this.form.pinJieCanShu = pinJieCanShu;

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl(this.url),
                    method: 'post',
                    data: this.$httpTAG.adornData(this.form)
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.dialogFormVisible = false;
                        this.$emit("handleCurrentChange", 1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })

            },
            zychange(thiss) {
                //摘要=号复制上一行摘要
                if ($(thiss).val() == "=") {
                    let thisTr = $(thiss).parents(".voucher-tr");
                    let val = this.getTrZy(thisTr);
                    $(thiss).val(val);
                }
            },
            getTrZy(thisTr) {
                //递归获取前一个不为空的摘要
                let prevTr = thisTr.prev();
                if (prevTr == undefined || prevTr == 'undefined') {
                    return "";
                }
                let val = prevTr.find("td[data-type='brief']").text();
                if ($.trim(val) == '') {
                    return this.getTrZy(prevTr);
                } else {
                    return $.trim(val);
                }
            }
        },
        mounted() {
            window.num = this.num;
            window.vdremove = this.vdremove;
            window.vdadd = this.vdadd;
            window.initselect = this.initselect;
            window.km_f = this.km_f;
            window.findKm = this.findKm;
            window.zychange = this.zychange;
        }
    }
</script>

<style scoped>
    .viewVcloud-main-body-B {
        overflow: hidden;
        overflow-y: auto;
        -o-transition: all 0.2s ease;
        -ms-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        margin: 10px 5px;
        height: 520px;
    }

    .qazqaz >>> .el-dialog__body {
        padding: 0px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .common-dialog >>> .el-dialog__body {
        padding: 10px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

</style>
